import React from 'react';
import { connect } from 'react-redux';
import PageContainer from '../../components/Redesing/page-container';
import DocumentsTable from './documents-table';

const Documents = ({ systemLoaded }: { systemLoaded: boolean }) => (
  <PageContainer isLoading={!systemLoaded} spaceName={'Documents'}>
    <DocumentsTable />
  </PageContainer>
);

export default connect((state: { system: { isLoaded: boolean } }) => ({
  systemLoaded: state.system.isLoaded,
}))(Documents);
